export default function normalizeName(name = '') {
  if (typeof name !== 'string' || !name) return '';

  return name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}
